<input id="dateRangeValue" name="dateRangeValue" class="form-control" placeholder="Zeitraum"
       bsDaterangepicker [(ngModel)]="dateRange" [bsConfig]="{ dateInputFormat: 'DD.MM.YYYY' }">
